import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const PriceTable = ({
  lineKeys = [],
  drugName = '',
  displayKeys = [],
  tableData = [],
  quantity = '',
  dosage = '',
  form = ''
}) => {
  const { t, i18n } = useTranslation();

  const activeColumns = useMemo(() => {
    return lineKeys?.filter(key =>
      tableData?.some(row => row[key] && row[key] != null && row[key] !== '')
    );
  }, [lineKeys, tableData]);

  const activeDisplayKeys = useMemo(() => {
    return displayKeys?.filter((_, idx) =>
      activeColumns.includes(lineKeys[idx])
    );
  }, [displayKeys, lineKeys, activeColumns]);

  return (
    <div>
      {i18n.language === 'en' ? (
        <h3 className="priceTableHeading">
          {t('Average 1 Month Prices for')} {drugName && drugName}
        </h3>
      ) : (
        <h3 className="priceTableHeading">
          {`${t('Average 1 Month Prices for')} ${drugName && drugName}`}
        </h3>
      )}
      <span className="qty-txt">
        {quantity} {t('count1')}, {form}, {dosage}
      </span>
      {tableData && tableData?.length > 1 && (
        <div className="tableWraper">
          <table>
            <thead className="table-head">
              <tr>
                <th>{t('Pharmacy')}</th>
                {activeDisplayKeys?.map((n, id) => (
                  <th key={id}>{n}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.name}</td>
                  {activeColumns?.map((key, colIdx) => (
                    <td key={colIdx}>
                      {row[key] ? `$${Number(row[key]).toFixed(2)}` : '-'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PriceTable;
